<template>
  <b-modal :active.sync="isActiveModal"
    has-modal-card
    trap-focus
    aria-role="dialog"
    aria-modal class="has-overflow">
      <div class="modal-card">
        <ValidationObserver ref="observer">
          <header class="modal-card-head">
              <p class="modal-card-title">{{titleForm}}</p>
          </header>
          <section class="modal-card-body" style="min-height: 200px;">
            <ValidationProvider
              name="Nombre"
              :rules="'required'"
              v-slot="{ errors }">
                <b-field
                  label="Nombre"
                  :type="{ 'is-danger': errors[0] }"
                  :message="errors">
                    <b-input  placeholder="Nombre descriptivo del día" v-model="name"></b-input>
                </b-field>
            </ValidationProvider>
            <ValidationProvider
              name="Fecha"
              :rules="'required'"
              v-slot="{ errors }">
              <b-field label="Fecha"
              :type="{ 'is-danger': errors[0] }"
              :message="errors">
                <b-datepicker
                      placeholder="Selecciona una fecha"
                      v-model="date"
                      :first-day-of-week="1"
                      :month-names="$moment.months()"
                      :day-names="$moment.weekdaysShort()"
                      :unselectable-days-of-week="[0]"
                      :mobile-native="false"
                      expanded>
                      <button class="button is-danger"
                          @click="date = null">
                          <b-icon icon="close"></b-icon>
                          <span>Limpiar</span>
                      </button>
                </b-datepicker>
              </b-field>
            </ValidationProvider>
            <b-field>
              <off-day-type-selector :value="typeId" @select="type = $event" :has-validator="true" rules="required" label="Tipo" name="type"/>
            </b-field>
            <b-field label="Observación">
              <b-input v-model="observations" maxlength="200" placeholder="Descripción breve del día" type="textarea"></b-input>
            </b-field>
            <!-- <div class="field">
                <b-checkbox v-model="checkboxCustom"
                    true-value="Yes"
                    false-value="No">
                    irrenuncuable
                </b-checkbox>
            </div> -->
          </section>
          <footer class="modal-card-foot">
            <b-button @click="isActiveModal = false">Cancelar</b-button>
            <b-button type="is-primary" @click="save" :loading="isLoading">Guardar</b-button>
          </footer>
        </ValidationObserver>
      </div>
    </b-modal>
</template>

<script>
import OffDayTypeSelector from '@/components/OffDayTypeSelector'
import OffDayService from '@/services/OffDayService'

export default {
  components: {
    OffDayTypeSelector
  },
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false
    },
    defaultDate: {
      required: false,
      type: Date,
      default: null
    },
    offDay: {
      required: false,
      type: Object,
      default: null
    }
  },
  data () {
    return {
      date: this.defaultDate,
      type: null,
      name: null,
      isActiveModal: false,
      isLoading: false,
      observations: null
    }
  },
  methods: {
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true

        let dateFormated = this.$moment(this.date).format('YYYY-MM-DD')
        let year = this.$moment(this.date).year()

        let data = {
          'date': dateFormated,
          'name': this.name,
          'observations': this.observations,
          'type': this.typeId,
          'year': year
        }

        try {
          let response = null
          let text = ''

          if (this.offDay) {
            response = await OffDayService.updateOffDays(this.offDay.id, data)
            text = 'Día editado exitosamente'
          } else {
            response = await OffDayService.createOffDays(data)
            text = 'Día bloqueado exitosamente'
          }

          if (response.status >= 200 && response.status < 300) {
            this.success(text)
            this.$emit('saved')
          }
        } catch (error) {
          console.log(error)
          this.error()
        }
        this.isLoading = false
        this.isActiveModal = false
      }
    },
    clearData () {
      this.date = null
      this.type = null
      this.name = null
      this.observations = null
      this.$emit('update:offDay', null)
    },
    success (text) {
      this.$buefy.toast.open({
        message: text,
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo realizar los cambios',
        type: 'is-danger'
      })
    }
  },
  watch: {
    active () {
      if (this.active !== this.isActiveModal) {
        this.isActiveModal = this.active
      }
    },
    isActiveModal () {
      if (this.isActiveModal !== this.active) {
        this.$emit('update:active', this.isActiveModal)
        if (!this.isActiveModal) {
          this.clearData()
        }
      }
    },
    defaultDate () {
      if (!this.offDay) {
        this.date = this.defaultDate
      }
    },
    offDay (value) {
      if (value) {
        this.date = this.$moment(value.date, 'YYYY-MM-DD').toDate()
        this.type = value.type
        this.name = value.name
        this.observations = value.observations
      }
    }
  },
  computed: {
    typeId () {
      return this.type ? this.type.id : null
    },
    titleForm () {
      return this.offDay ? 'Editar Día' : 'Agregar Día'
    }
  }
}
</script>
